<template>
  <div class="sp-index-filters-footer">
    <sp-button
      v-if="store.activeChooser"
      :data-testid="TestId.admin.indexFiltersMore"
      variant="text"
      color="primary"
      @click="emit('choose')"
      >{{ t("more_filters") }}</sp-button
    >
    <sp-button
      variant="text"
      color="primary"
      :data-testid="TestId.admin.indexFiltersClear"
      :disabled="!canClear"
      @click="clearAll"
      >{{ t("clear_all") }}</sp-button
    >
  </div>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { useIndexFiltersStore } from "#ce/apps/SpAdmin/SpIndexFilters/store/index-filters";
import { t } from "#ce/apps/SpAdmin/SpIndexFilters/i18n";

const emit = defineEmits(["change", "choose"]);
const store = useIndexFiltersStore();
const canClear = computed(() => !store.loading && store.tabs.length > 0);

function clearAll() {
  store.clearAll();
  emit("change");
}
</script>

<style scoped>
.sp-index-filters-footer {
  display: flex;
  justify-content: center;
  gap: var(--sp-ref-scale-16);
  padding: var(--sp-ref-scale-8) var(--sp-ref-scale-16);
  border-top: var(--sp-sys-border-width-default) solid var(--sp-sys-color-outline);
}
</style>
